module.exports = new __parcel__URL__("73091264-1.cc309a38.png").toString();